import { useHookstate } from "@hookstate/core";
import { MESSAGE_COUNT, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";

const useInboxMessagesCount = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { MessageNumber } = useHookstate(MESSAGE_COUNT);
  const { getMessagesFromCarsData } =
    useSelector((state) => state.commonReducers) || [];
  const { carMessagesBackup } =
    useSelector((state) => state.firstReducer) || [];
  const [messageData, setMessageData] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem("dismissedIds")) {
      let tempData = [];
      localStorage.setItem("dismissedIds", JSON.stringify(tempData));
    }
  }, [localStorage.getItem("dismissedIds")]);

  useEffect(() => {
    if (siteId.get() !== null) {
      setMessageData([]);
      if (messageData.length !== 0) {
        messageData.forEach((msg) => {
          let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds"));
          dismissedIds.push(msg.Id);
          localStorage.setItem("dismissedIds", JSON.stringify(dismissedIds));
        });
      }
    }
  }, [siteId.get()]);

  useEffect(() => {
    let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds"));
    let messageDataGetter = [] || [];
    if (carMessagesBackup && carMessagesBackup?.length !== 0) {
      messageDataGetter =
        getMessagesFromCarsData &&
        getMessagesFromCarsData?.Messages &&
        getMessagesFromCarsData?.Messages?.length !== 0 &&
        getMessagesFromCarsData?.Messages?.filter((item) => {
          if (!carMessagesBackup.includes(item.Id)) {
            return {
              ...item,
              id: item?.Id,
              received: moment(item?.Created).unix(),
              car: item?.CarNum,
              text: item?.Text,
              response: item?.Response,
              hole: item?.Hole,
            };
          }
        });
    } else {
      messageDataGetter =
        getMessagesFromCarsData &&
        getMessagesFromCarsData?.Messages &&
        getMessagesFromCarsData?.Messages?.length !== 0
          ? getMessagesFromCarsData?.Messages?.map((item, i) => {
              return {
                ...item,
                id: item?.Id,
                received: moment(item?.Created).unix(),
                car: item?.CarNum,
                text: item?.Text,
                response: item?.Response,
                hole: item?.Hole,
              };
            })
          : "";
    }
    if (messageDataGetter && messageDataGetter?.length !== 0) {
      let finalMessages = messageDataGetter?.filter(
        (msg) => !dismissedIds.includes(msg.Id)
      );

      setMessageData(finalMessages);
      MessageNumber.set(finalMessages.length);
    }
  }, [
    carMessagesBackup,
    getMessagesFromCarsData,
    localStorage.getItem("dismissedIds"),
  ]);

  return {
    msgInboxCount: messageData.length,
  };
};

export default useInboxMessagesCount;
